export default __webpack_public_path__ + "static/media/avatar_73.c2f38ae6.png";